import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import UserContext from "../../context/userContext";
import PageLoading from "../Globo/PageLoading/PageLoading";
import { PUBLIC_PATHS } from "../../shared/constants/public-paths";
import { setRedirectUrl } from "../../shared/constants/redirect-store";

// Gates the whole app: redirects unauthenticated users to /login and waits for "me" to load,
// unless they're on a public path.
const AuthGate = ({ children }) => {
  const { me, userIsAuthenticated } = useContext(UserContext);
  const { pathname, search } = useLocation();

  if (PUBLIC_PATHS.includes(pathname)) return <>{children}</>;

  if (!userIsAuthenticated) {
    setRedirectUrl(pathname + search);

    return <Navigate to="/login" replace />;
  }

  if (me.loading) return <PageLoading />;

  return <>{children}</>;
};

export default AuthGate;
